import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { getProduct } from '../../product-catalog/productPresentation';
import { assetUrl } from '../shared/assetUrl';

export default function SuccessStoryCard({ interview, register, pauseOthers }) {
  const { t } = useTranslation('app');
  const product = getProduct(interview.productId);
  const title = t(`${interview.translationKey}.title`);
  const summary = t(`${interview.translationKey}.summary`, { returnObjects: true });
  const videoUrl = assetUrl(interview.video);
  return (
    <article className="success-story" aria-labelledby={`${interview.id}-title`}>
      <div className="success-story-media">
        <video ref={video => register(interview.id, video)}
          controls playsInline preload="none" aria-label={title}
          poster={assetUrl(interview.poster)}
          onPlay={() => pauseOthers(interview.id)}>
          <source src={videoUrl} type="video/mp4" />
          {t('successStories.videoFallback')}
          <a href={videoUrl}>{t('successStories.openVideo')}</a>
        </video>
      </div>
      <div className="success-story-content">
        <span className="success-story-product">{product.name}</span>
        <h2 id={`${interview.id}-title`}>{title}</h2>
        <h3>{t('successStories.summaryTitle')}</h3>
        <ul className="success-story-summary">
          {summary.map(item => (
            <li key={item.label}>
              <strong>{item.label}</strong>
              <span>{item.text}</span>
            </li>
          ))}
        </ul>
        <div className="success-story-actions">
          <a href={videoUrl} target="_blank" rel="noopener noreferrer">
            {t('successStories.openVideo')} <span aria-hidden="true">↗</span>
          </a>
          <Link to={product.path}>
            {t('successStories.viewProduct', { product: product.name })} <span aria-hidden="true">→</span>
          </Link>
        </div>
      </div>
    </article>
  );
}
